import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const RiskManagementWrapper = (): ReactElement => <Outlet />;

export default RiskManagementWrapper;
